import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import AdminUsersPage from './pages/AdminUsersPage';
import EditorPage from './pages/EditorPage';
import LoginPage from './pages/LoginPage';
import ProjectLibraryPage from './pages/ProjectLibraryPage';
import { useAuthStore } from './store/authStore';

export default function App() {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const checked = useAuthStore((s) => s.checked);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (!checked) {
    return null;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <ProjectLibraryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:id"
        element={
          <ProtectedRoute>
            <EditorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute adminOnly>
            <AdminUsersPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
